var _path, _path2, _path3, _path4, _path5, _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 42C32.8218 42 42 32.8218 42 21.5C42 10.1782 32.8218 1 21.5 1",
    stroke: "url(#paint0_linear_2376_6392)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.5C1 32.8218 10.1782 42 21.5 42",
    stroke: "#E4E4E4",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.5C1 10.1782 10.1782 1 21.5 1",
    stroke: "#E4E4E4",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 28C11.98 22.88 12.82 19.58 15.66 15.66H9V13.2H18.82V14.98C15.38 19.18 14.94 22.22 14.68 28H11.7Z",
    fill: "#E4E4E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.132 31.148L20.732 19.472H21.512L17.924 31.148H17.132ZM22.7552 29V28.088H24.7112V21.536H23.1392V20.828C23.9312 20.696 24.4952 20.492 24.9632 20.204H25.8032V28.088H27.5792V29H22.7552ZM31.4875 29.168C30.1195 29.168 29.2795 28.592 28.6795 27.992L29.2315 27.272C29.7235 27.788 30.3715 28.256 31.3795 28.256C32.4235 28.256 33.2515 27.452 33.2515 26.18C33.2515 24.92 32.5315 24.164 31.4395 24.164C30.8515 24.164 30.4795 24.356 29.9755 24.692L29.3875 24.32L29.6635 20.204H33.9475V21.14H30.6235L30.3955 23.684C30.7915 23.468 31.1875 23.336 31.7155 23.336C33.1795 23.336 34.3675 24.2 34.3675 26.144C34.3675 28.064 32.9635 29.168 31.4875 29.168Z",
    fill: "#E4E4E4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4954,
    cy: 41.9273,
    r: 1.92518,
    transform: "rotate(-135 20.4954 41.9273)",
    fill: "url(#paint1_linear_2376_6392)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2376_6392",
    x1: 72.4296,
    y1: 1,
    x2: 72.4296,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2376_6392",
    x1: 28.1359,
    y1: 40.0021,
    x2: 28.1359,
    y2: 43.8525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepPieChart);
export default __webpack_public_path__ + "static/media/step_pie-chart.922b6c44.svg";
export { ForwardRef as ReactComponent };